module.exports = __webpack_public_path__ + "media/assets/images/category/Baby@2x-5d2577f36d819f9709c93efbaec8b331.png";